export const shopI18n = {};
